module.exports = __webpack_public_path__ + "static-portal/img/icon-07.1da67f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/HomeManage/module/icons/icon-07.png
// module id = tjZu
// module chunks = 4